// utils/gridOperations.js
import {
    updateGUIInstrumentsToBackend,
    updateTickerSubscriptionWithKite,
    addPosition,
    updateAllPositions, setSubscriptionToDetails, updateTokenSubscriptionWithKite, setSubscriptionToQuote
} from "../../../services/apiService";
import { tickStorage } from "@dashboard/contexts/tickStore"; // ⬅️ NEW

import WebSocketService from "../../../../websockets/WebSocketService";

export const handleAddToOldGrid = (instrument, atIndex, layouts, setLayouts, tabID, setGUIInstruments) => {
    const newLayout = {
        i: `${tabID}-${instrument.instrumentToken}`,
        x: 0,
        y: atIndex,
        w: 12,
        h: 1
    };

    const updatedLayouts = layouts.map(layout => ({
        ...layout,
        y: layout.y >= atIndex ? layout.y + 1 : layout.y
    }));
    updatedLayouts.splice(atIndex, 0, newLayout);

    const instrumentWithTabIDAndSequence = {
        ...instrument,
        tabID: tabID,
        sequenceNumber: atIndex
    };

    setGUIInstruments(prevGUIInstruments => {
        const updatedGUIInstruments = prevGUIInstruments.map((existingInstrument, index) => {
            if (index >= atIndex) {
                return { ...existingInstrument, sequenceNumber: existingInstrument.sequenceNumber + 1 };
            }
            return existingInstrument;
        });

        updatedGUIInstruments.splice(atIndex, 0, instrumentWithTabIDAndSequence);
        updateGUIInstrumentsToBackend(updatedGUIInstruments, tabID);
        updateTickerSubscriptionWithKite(updatedGUIInstruments, tabID)
        return updatedGUIInstruments;
    });

    setLayouts(updatedLayouts);
};


// Handle sorting toggle (with "none" state sorting by sequenceNumber)
export const handleSortToggle = (sortDirection, setSortDirection, GUIInstruments, setGUIInstruments, setLayouts,tabID) => {
    const newSortDirection = sortDirection === 'asc' ? 'desc' : sortDirection === 'desc' ? 'none' : 'asc';
    setSortDirection(newSortDirection);

    // If no sorting is applied, sort by sequenceNumber
    if (newSortDirection === 'none') {
        const sortedBySequence = [...GUIInstruments].sort((a, b) => a.sequenceNumber - b.sequenceNumber);
        setGUIInstruments(sortedBySequence);

        const sortedLayouts = sortedBySequence.map((instrument, index) => ({
            i: `${tabID}-${instrument.instrumentToken}`,
            x: 0,
            y: index, // Update the y value based on the sorted order
            w: 12,
            h: 1,
        }));

        setLayouts(sortedLayouts);
        return;  // Exit here since sorting by sequenceNumber is done
    }

    const getPriceDiffPercent = (instrumentToken) => {
        const tick = tickStorage.latest[instrumentToken]; // live tick from WebSocket
        if (!tick || !tick.lastTradedPrice || !tick.closePrice) return 0;

        const ltp = tick.lastTradedPrice;
        const close = tick.closePrice;
        if (!close) return 0;

        const percentageDifference = ((ltp - close) / close) * 100;
        return percentageDifference; // numeric; no toFixed here so sorting is precise
    };

    // Sort GUIInstruments based on the current priceDifferencePercentage
    const sortedInstruments = [...GUIInstruments].sort((a, b) => {
        const aPriceDiff = getPriceDiffPercent(a.instrumentToken);
        const bPriceDiff = getPriceDiffPercent(b.instrumentToken);

        if (newSortDirection === 'asc') {
            return aPriceDiff - bPriceDiff;
        } else {
            return bPriceDiff - aPriceDiff;
        }
    });

    // Update layouts to reflect the new sorted order
    const sortedLayouts = sortedInstruments.map((instrument, index) => ({
        i: `${tabID}-${instrument.instrumentToken}`,
        x: 0,
        y: index, // Update the y value based on the sorted order
        w: 12,
        h: 1,
    }));

    setGUIInstruments(sortedInstruments);
    setLayouts(sortedLayouts);
};


   /* // Update the layout to increase the height of the clicked grid item
    setLayouts(prevLayouts => {
        const updatedLayouts = prevLayouts.map(layout => {
            if (layout.i === `${tabID}-${instrumentToken}`) {
                return { ...layout, h: layout.h + 1 };  // Increase the height by 1 (or more, depending on content)
            }
            return layout;
        });
        return updatedLayouts;
    });*/

const waitForFirstTick = (instrumentTokenValue, maxWaitMs = 3000, intervalMs = 100) =>
    new Promise((resolve) => {
        const start = Date.now();

        const check = () => {
            const tick = tickStorage.latest[instrumentTokenValue];
            if (tick && tick.lastTradedPrice) {
                resolve(tick);
                return;
            }

            if (Date.now() - start >= maxWaitMs) {
                // Give up after maxWaitMs – we’ll proceed with avgBuyPrice = null
                resolve(null);
                return;
            }

            setTimeout(check, intervalMs);
        };

        check();
    });

export const handleAddPositionFromSearchBar = async (
    instrumentToken,
    GUIInstrument,
    currentlyHeldPositions,
    setGUIInstruments,          // still kept for compatibility, but unused here
    tabID,
    _tickFromContext,           // we ignore TickContext tick now
    setCurrentlyHeldPositions,
    posGridlayouts,
    setPosGridlayouts,
    PosGridTabID
) => {
    const exists = currentlyHeldPositions.some(
        pos => pos.instrumentToken === GUIInstrument.instrumentToken
    );
    if (exists) return;

    // *** GET SEQUENCE NUMBER ***
    const nextSequenceNumber =
        currentlyHeldPositions.length > 0
            ? Math.max(...currentlyHeldPositions.map(p => p.sequenceNumber ?? 0)) + 1
            : 0;

    const tradingsymbol      = GUIInstrument.tradingsymbol;
    const instrumentTokenValue = GUIInstrument.instrumentToken;
    const exchangeNameValue    = GUIInstrument.exchange;
    const exchangeTokenValue   = GUIInstrument.exchangeToken;

    const todayDate = new Date().toISOString().split('T')[0];

    // 1️⃣ Start subscription for this instrument
    await updateTickerSubscriptionWithKite(GUIInstrument, tabID);

    // 2️⃣ Wait for first tick for this token
    const tickForToken = await waitForFirstTick(instrumentTokenValue);

    // 3️⃣ Build position using the tick we just waited for
    const position = {
        tradingsymbol: tradingsymbol,
        instrumentToken: instrumentTokenValue,
        exchange: exchangeNameValue,
        exchangeToken: exchangeTokenValue,
        avgBuyPrice: tickForToken?.lastTradedPrice ?? null,
        date: todayDate,
        sequenceNumber:nextSequenceNumber
    };

    // 4️⃣ Persist + update local state
    addPosition(position);

    setCurrentlyHeldPositions(prevPositions => [
        ...prevPositions,
        position
    ]);

    const newLayout = {
        i: `${PosGridTabID}-${instrumentTokenValue}`,
        x: 0,
        y: posGridlayouts.length,
        w: 12,
        h: 1,
    };

    setPosGridlayouts(prevLayouts => [
        ...prevLayouts,
        newLayout
    ]);
};
export const handleAddPosition = (
    GUIInstrument,
    setLayouts,
    tabID,
    tick,
    setCurrentlyHeldPositions,
    posGridlayouts,
    setPosGridlayouts,
    PosGridTabID
) => {
    // Extract tradingSymbol and instrumentToken from GUIInstrument
    const tradingSymbol = GUIInstrument.tradingsymbol;
    const instrumentTokenValue = GUIInstrument.instrumentToken;
    const exchangeNameValue = GUIInstrument.exchange;
    const exchangeTokenValue = GUIInstrument.exchangeToken;

    // Get today's date in the format yyyy-MM-dd
    const todayDate = new Date().toISOString().split('T')[0]; // yyyy-MM-dd format

    // Create the position object using tick.lastTradedPrice for avgBuyPrice and add today's date
    const position = {
        tradingsymbol: tradingSymbol,
        instrumentToken: instrumentTokenValue,
        exchange: exchangeNameValue,
        exchangeToken: exchangeTokenValue,
        avgBuyPrice: tick.lastTradedPrice, // Assign lastTradedPrice from TickContext to avgBuyPrice
        date: todayDate,  // Add today's date in yyyy-MM-dd format
        tabID: tabID
    };

    // Call addPosition to persist the position in the backend or other logic
    addPosition(position);
    /*setSubscriptionToDetails(instrumentTokenValue);*/
    /*updateTokenSubscriptionWithKite(instrumentTokenValue,PosGridTabID);*/
    // Update the currentlyHeldPositions state by adding the new position
    setCurrentlyHeldPositions(prevPositions => [...prevPositions, position]);

    // Update the posGridlayouts by adding a new layout for the new position
    const newLayout = {
        i: `${PosGridTabID}-${instrumentTokenValue}`,  // Unique key based on tabID and instrumentToken
        x: 0,
        y: posGridlayouts.length,  // Set the new layout at the next available row
        w: 12,
        h: 1,
    };

    // Update the layout by appending the new layout entry
    setPosGridlayouts(prevLayouts => [...prevLayouts, newLayout]);
};

export const handleDeleteFromOldGrid = (GUIInstrument, setGUIInstruments, setLayouts, tabID) => {
    /*console.log("in handleDeleteFromOldGrid");*/
    setGUIInstruments((prevGUIInstruments) => {
        /*console.log("in setGUIInstruments");
        console.log("instrumentToken to be deleted: ",instrumentToken);*/
        // Find the sequenceNumber of the instrument to be deleted
        const deletedInstrument = prevGUIInstruments.find(instrument => instrument.instrumentToken === GUIInstrument.instrumentToken);
        const deletedSequenceNumber = deletedInstrument.sequenceNumber;

        // Remove the instrument and update sequenceNumbers of the remaining instruments
        const updatedInstruments = prevGUIInstruments
            .filter(instrument => instrument.instrumentToken !== GUIInstrument.instrumentToken) // Remove the deleted instrument
            .map(instrument => {
                // Decrement sequenceNumber of instruments after the deleted one
                if (instrument.sequenceNumber > deletedSequenceNumber) {
                    return {
                        ...instrument,
                        sequenceNumber: instrument.sequenceNumber - 1,
                    };
                }
                return instrument;
            });

        // Call the backend API to update the instruments
        updateGUIInstrumentsToBackend(updatedInstruments, tabID);
        updateTickerSubscriptionWithKite(updatedInstruments, tabID);

        // Return the updated instruments to update the state
        return updatedInstruments;
    });

    // Update layouts by recalculating the positions of the remaining items
    // Update layouts by removing the deleted instrument
    /*console.log("recalculatedLayouts: ",recalculatedLayouts);*/
    setLayouts((prevLayouts) => {
        /*console.log("in setLayouts");*/
        const updatedLayouts = prevLayouts.filter(layout => layout.i !== `${tabID}-${GUIInstrument.instrumentToken}`);

        // Recalculate the y position for the remaining items
        const recalculatedLayouts = updatedLayouts.map((layout, index) => ({
            ...layout,
            y: index,  // Reset the y position based on the new order
        }));

        // Increment the layoutKey to trigger re-render
        /*setLayoutKey(prevKey => prevKey + 1);  */ // This forces GridLayout to re-render
        /*console.log("recalculatedLayouts: ",recalculatedLayouts);*/
        return recalculatedLayouts;
    });
}

    export const handleDeletePosition = (instrumentToken, GUIInstrument, setGUIInstruments, setPosGridlayouts, tabID) => {
        let updatedInstruments;

        setGUIInstruments((prevGUIInstruments) => {
            // Filter out the instrument with the matching token
            updatedInstruments = prevGUIInstruments.filter(instrument => instrument.instrumentToken !== instrumentToken);
            // Return the original state without changes
            return prevGUIInstruments;
        });

        // Call updateAllPositions with the updated instruments
        updateAllPositions(updatedInstruments);

        setPosGridlayouts((prevLayouts) => {
            /*console.log("in setLayouts");*/
            const updatedLayouts = prevLayouts.filter(layout => layout.i !== `${tabID}-${instrumentToken}`);

            // Recalculate the y position for the remaining items
            const recalculatedLayouts = updatedLayouts.map((layout, index) => ({
                ...layout,
                y: index,  // Reset the y position based on the new order
            }));

            // Increment the layoutKey to trigger re-render
            /*setLayoutKey(prevKey => prevKey + 1);  */ // This forces GridLayout to re-render
            /*console.log("recalculatedLayouts: ",recalculatedLayouts);*/
            return recalculatedLayouts;
        });
        setGUIInstruments(updatedInstruments);
    };

export const isSameAnnouncement = (a, b) =>
    a.broadcastTime === b.broadcastTime && a.message === b.message;


